import React from 'react';
import './style.css';
// import './bootstrap.min.css';
import './build/dist/index.css';
import './build/dist/index.js';
import { Title } from 'react-admin';

const ThermalStep = () => {
    return (
        <>
            <Title title={'THERMAL-STEP ORDERS'}></Title>
        </>
    );
};

const ThermalStepPage = {
    name: 'ThermalStep',
    list: ThermalStep
};

export default ThermalStepPage;
